import "core-js/modules/es.regexp.exec.js";
export var positiveDoublePattern = function positiveDoublePattern(val) {
  return /^\d{0,2}(\.\d{0,2}){0,1}$/.test(val);
};
export var positiveIntPattern = function positiveIntPattern(val) {
  return /^0$|^[1-9][0-9]{0,}$/.test(val);
};
export var digitsOnlyPattern = function digitsOnlyPattern(val) {
  return /^\d+$/.test(val);
};